/**
 *
 * Asynchronously loads the component for SelectRolePage
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const SelectRolePage = lazyLoad(
  () => import('./index'),
  module => module.SelectRolePage,
);
